var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIconWithdot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0013 26.584C14.9508 26.584 15.7726 25.9886 16.1359 25.1406C16.3533 24.6329 15.8869 24.1673 15.3346 24.1673H12.668C12.1157 24.1673 11.6493 24.6329 11.8667 25.1406C12.23 25.9886 13.0518 26.584 14.0013 26.584ZM21.2819 19.6246C21.1019 19.4382 21.0013 19.1892 21.0013 18.93V13.2923C21.0013 9.86925 19.382 6.96062 16.501 5.88614C16.0696 5.72522 15.7513 5.33186 15.7513 4.87138V4.83398C15.7513 3.83107 14.9696 3.02148 14.0013 3.02148C13.033 3.02148 12.2513 3.83107 12.2513 4.83398V4.87203C12.2513 5.33221 11.9334 5.72541 11.5024 5.88649C8.62993 6.95991 7.0013 9.8587 7.0013 13.2923V18.93C7.0013 19.1892 6.9007 19.4382 6.7207 19.6246L4.90947 21.5005C4.75455 21.661 4.66797 21.8753 4.66797 22.0983C4.66797 22.5737 5.0533 22.959 5.52862 22.959H22.474C22.9493 22.959 23.3346 22.5737 23.3346 22.0983C23.3346 21.8753 23.2481 21.661 23.0931 21.5005L21.2819 19.6246ZM18.668 19.5423C18.668 20.0946 18.2203 20.5423 17.668 20.5423H10.3346C9.78235 20.5423 9.33464 20.0946 9.33464 19.5423V13.2923C9.33464 10.2957 11.0963 7.85482 14.0013 7.85482C16.9063 7.85482 18.668 10.2957 18.668 13.2923V19.5423Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#FF5D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconWithdot);
export default __webpack_public_path__ + "static/media/notificationIconWithdot.b299514f218caec038550428f12368e0.svg";
export { ForwardRef as ReactComponent };